import { Table } from 'antd';
import dayjs from 'dayjs';
import { useCallback, useReducer } from 'react';
import { useTranslation } from 'react-i18next';
import { useGetStockAuditTrailsQuery } from '../../../api/queries/getStockAuditTrails';
import PaginatedTable, { pageReducer } from '../../../components/PaginatedTable';
import InternalErrorResult from '../../../components/results/InternalErrorResult';

type ActivityLogTabProps = {
    inventoryId: string;
    stockId: string;
};

const ActivityLogTab = ({ stockId, inventoryId }: ActivityLogTabProps) => {
    const { t } = useTranslation(['inventoryDetails', 'common', 'applicationDetails']);
    const [state, dispatch] = useReducer(pageReducer, { page: 1, pageSize: 10 });

    const { page, pageSize } = state;
    const { data, loading, error } = useGetStockAuditTrailsQuery({
        fetchPolicy: 'cache-and-network',
        variables: {
            inventoryId,
            stockId,
            pagination: { limit: pageSize, offset: (page - 1) * pageSize },
        },
    });

    const renderDate = useCallback(
        (value: string | Date) => dayjs(value).format(t('common:formats.dateTimeFormat')),
        [t]
    );
    if (!loading && error) {
        return <InternalErrorResult />;
    }

    return (
        <PaginatedTable
            dataSource={data?.result?.items ?? []}
            dispatch={dispatch}
            state={state}
            tableName={t('applicationDetails:tabs.activityLog')}
            total={data?.result?.count ?? 0}
        >
            <Table.Column
                key="date"
                dataIndex="date"
                render={renderDate}
                title={t('inventoryDetails:columns.title')}
                width="300px"
            />
            <Table.Column key="message" dataIndex="message" title={t('inventoryDetails:columns.activity')} />
        </PaginatedTable>
    );
};

export default ActivityLogTab;
